// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../CommunityWebPortal/_app/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#studentSchedule[data-v-a79997b8]{border:1px solid #d3d3d3}#studentSchedule.text-center>thead>tr>th[data-v-a79997b8]{text-align:center}", ""]);
// Exports
module.exports = exports;
